import React from "react";

const Impressum = ({ darkTheme }) => {
  return (
    <div
      id="impressum"
      className="modal fade"
      role="dialog"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div
          className={
            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
          }
        >
          <div className="modal-header">
            <h5 className={"modal-title " + (darkTheme ? "text-white" : "")}>
              Impressum
            </h5>
            <button
              type="button"
              className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body p-4">
            <p>
            Informationspflicht laut §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch, §63 Gewerbeordnung und Offenlegungspflicht laut §25 Mediengesetz.
            </p>
            <p>
            Johannes Skalla<br />
            Am Freihof 68,<br />
            1220 Wien,<br />
            Österreich<br />
            <br />
            {/*<b>Tel.:</b> 0043 (0) 660 563 55 04<br />*/}
            <b>Email:</b> office[at]kejo.at<br />
            <br />
            <b>Unternehmensgegenstand:</b> IT Dienstleistungen<br />
            <b>Berufsbezeichnung:</b> IT-System-Engineer<br />
            <b>Verleihungsstaat:</b> Österreich
            </p>
            <p>
            <b>Datenschutzbeauftragter:</b> Johannes Skalla<br />
            <b>E-Mail:</b> datenschutz[at]kejo.at
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
